import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ThemeProvider } from './hooks/useTheme'
import { AdminThemeProvider } from './hooks/useAdminTheme'
import './styles/index.css'
import './styles/admin-futuristic.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AdminThemeProvider>
          <App />
        </AdminThemeProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
)